import { useMutation } from "@tanstack/react-query";
import uploadsApiClient, { UploadFileInput } from "../../../api/uploads";

const useUploadChimeMutation = () => {
  return useMutation({
    mutationFn: (input: UploadFileInput) => uploadsApiClient.uploadChime(input),
  });
};

export default useUploadChimeMutation;
